import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { UserStoreEffects } from './user-store.effects';
import { reducer, userStoreFeatureKey } from './user-store.reducers';

export function provideUserStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(userStoreFeatureKey, reducer),
    provideEffects([UserStoreEffects]),
  ]);
}
